import ResearchPaper from './ResearchPaper'; 

export default ResearchPaper; 